<template>
  <div>
    <h1>Our Blog</h1>
  </div>
</template>

<script lang="ts">
import { mapState } from 'pinia';
import type { Component } from '~/types';
import indexGlobal from '~/mixins/index.global';
import { BlogsMixin } from '~/units/blogs/mixins/blogs.mixin';
import { ComponentMixin } from '~/mixins/component.mixin';
import { useBlogsStore } from '~/units/blogs/store';
import { useWebsiteStore } from '~/units/website/store';
import { ROUTES } from '~/constants/ui.constants';
import Loader from '~/components/common/Loader.vue';
import BlockSymbol from '~/components/common/BlockSymbol.vue';
export default defineNuxtComponent({
  name: 'Theme9OurBlog',

  mixins: [BlogsMixin, indexGlobal, ComponentMixin],

  components: {
    Loader,
    BlockSymbol,
  },

  data() {
    return {
      swiper: null,
      canPaginateBack: true,
      canPaginateNext: true,

      variants: {
        v1: 'v1',
        v2: 'v2',
      },
    };
  },

  async setup(props: { component: Component }) {
    const blogsStore = useBlogsStore();
    await blogsStore.fetchBlogsInPage(props.component);
  },

  computed: {
    ...mapState(useWebsiteStore, ['sidebarComponents']),
    ROUTES() {
      return ROUTES;
    },
    cards() {
      return this.groupedVariables.cards;
    },
  },

  methods: {
    onSwiper(swiper) {
      this.swiper = swiper;
    },

    onSlideChange() {
      if (!this.swiper) return;
      const isAtStart = this.swiper.isBeginning;
      const isAtEnd = this.swiper.isEnd;
      if (isAtStart) this.canPaginateBack = false;
      else this.canPaginateBack = true;
      if (isAtEnd) this.canPaginateNext = false;
      else this.canPaginateNext = true;
    },

    slidePrev() {
      try {
        if (this.swiper) {
          this.swiper.slidePrev();
        }
      } catch (error) {
        console.error('Error in slidePrev:', error);
      }
    },

    slideNext() {
      try {
        if (this.swiper) {
          this.swiper.slideNext();
        }
      } catch (error) {
        console.error('Error in slideNext:', error);
      }
    }
  },
  mounted() {
    this.onSlideChange();
  },
});
</script>
<style scoped>
.block {
  font-size: 32rem !important;
  font-weight: 700 !important;
  color: var(--c-secondary);
  line-height: 0.8;
  z-index: -1 !important;
  margin: 0;
  padding: 0;
  position: absolute;
  bottom: 0 !important;
  left: -80px !important;
}
</style>
